import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CommonService } from 'src/@services/common.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { Title } from '@angular/platform-browser';
import { responseMessageStatus, ResponseStatus } from 'src/@shared/shared/enum';
import { environmentURL } from 'src/environments/environment';
import { debounceTime, Subject, switchMap } from 'rxjs';
import { SsoHandoffService } from 'src/@shared/auth';
import { ProfileMenuUser } from 'src/app/pages/common-layout/account-settings/profile-menu/profile-menu.component';

@Component({
    selector: 'app-switch-ac',
    templateUrl: './switch-ac.component.html',
    styleUrls: ['./switch-ac.component.scss'],
    standalone: false
})
export class SwitchAcComponent implements OnInit {
  //#region properties
  isVisibleSwitchAccountModal = true;
  @Output() hideSwitchAccountModal = new EventEmitter();
  listOfAllocatedSites: object[] = [];
  listOfSupplierAllocatedSites: object[] = [];
  listOfSupplierBankAllocatedSites: object[] = [];
  isSiteSelected: boolean = false;
  userInfo: ProfileMenuUser = JSON.parse(localStorage.getItem('UserInfo') || '{}');
  BearerToken = localStorage.getItem('BearerToken');
  userDetails: any = JSON.parse(
    localStorage.getItem('UserInfo') || '{}'
  );
  canAccessSummary: boolean = true;
  isDataLoaded = false;
  listOfSuppliers: any[] = [];
  listOfAccounts: any[] = [];
  listOfSupplierBanks: any[] = [];
  selectedSupplier: any;
  selectedAccount: any;
  selectedSupplierBank: any;
  listOfSites: any[] = [];
  isVisibleAccountFilter: boolean = false;
  isVisibleSupplierFilter: boolean = false;
  isVisibleSupplierBankFilter: boolean = false;
  searchText: string = '';
  userRole: string = '';
  selectedSupplierDetails: any = JSON.parse(
    sessionStorage.getItem('SupplierDetails') || '{}'
  );
  searchTextChanged = new Subject<string>();
  isSearch: boolean = false;
  noAccountsAssigned = false;
  NoSearchRecordFound: boolean = false;
  listOfSBSites: any[];
  //#endregion

  //constructor
  constructor(
    public _router: Router,
    private location: Location,
    public _cs: CommonService,
    private _iS: InnerPagesService,
    private titleService: Title,
    private ssoHandoff: SsoHandoffService
  ) {
    this.titleService.setTitle('Switch Account - PayBev Supplier');
  }

  //#region functions
  ngOnInit(): void {
    //to check whether site is selected or not
    const BearerToken = localStorage.getItem('BearerToken');
    this.userRole = localStorage.getItem('UserRole');

    if (BearerToken == null) {
      this._router.navigate(['/login']);
    } else {
      this.getUserSites();

      this.isSiteSelected =
        localStorage.getItem('IsSiteSelected') == 'true' ? true : false;
      this.searchTextChanged
        .pipe(
          debounceTime(500),
          switchMap((text: string) => {
            this.isDataLoaded = true;
            this.isSearch = text?.length >= 3 ? true : false;
            return this._iS.getUserAccountsSites(text);
          })
        )
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            if (typeof response.result == 'string') {
              this.NoSearchRecordFound = true;
              // this._cs.displayMessage(responseMessageStatus.error, response.result);

              this.selectedAccount = null;
              this.selectedSupplier = null;
              this.selectedSupplierBank = null;
              this.listOfAllocatedSites = [];
              this.listOfSupplierAllocatedSites = [];
              this.listOfSupplierBankAllocatedSites = [];
            } else {
              this.selectedAccount = null;
              this.selectedSupplier = null;
              this.selectedSupplierBank = null;

              this.listOfAccounts = response.result.operator;
              this.listOfSuppliers = response.result.supplier;
              this.listOfSupplierBanks = response.result.supplierBank;

              if (this.listOfAccounts?.length > 0) {
                this.isVisibleAccountFilter = true;
                if (
                  Object.keys(this.selectedSupplierDetails)?.length > 0 &&
                  !this.isSearch
                ) {
                  this.selectedAccount = this.selectedSupplierDetails.AccountId;
                  this.onSelectAccount(this.selectedAccount);
                } else {
                  // this.selectedAccount = null;
                  this.onSelectAccount();
                }
              } else {
                this.listOfAllocatedSites = [];
              }

              if (this.listOfSuppliers?.length > 0) {
                this.isVisibleSupplierFilter = true;
                if (
                  Object.keys(this.selectedSupplierDetails)?.length > 0 &&
                  !this.isSearch
                ) {
                  this.selectedSupplier =
                    this.selectedSupplierDetails.id;
                  this.onSelectSupplier(this.selectedSupplier);
                } else {
                  // this.selectedSupplier = null;
                  this.onSelectSupplier();
                }
              } else {
                this.listOfSupplierAllocatedSites = [];
              }

              if (this.listOfSupplierBanks?.length > 0) {
                this.isVisibleSupplierBankFilter = true;
                if (
                  Object.keys(this.selectedSupplierDetails)?.length > 0 &&
                  !this.isSearch
                ) {
                  this.selectedSupplierBank =
                    this.selectedSupplierDetails.AccountId;
                  this.onSelectSupplierBank(this.selectedSupplierBank);
                } else {
                  // this.selectedSupplierBank = null;
                  this.onSelectSupplierBank();
                }
              } else {
                this.listOfSupplierBankAllocatedSites = [];
              }

              localStorage.setItem(
                'AllocatedSites',
                JSON.stringify(response.result)
              );
            }

            this.isDataLoaded = false;
          } else {
            this._cs.displayMessage(
              responseMessageStatus.error,
              response.message
            );
            this.isDataLoaded = false;
            this._cs.logOut();
          }
        });
    }
  }

  onSearch(event: any) {
    this.searchText = event;
    this.selectedSupplierBank = null;
    this.selectedSupplier = null;
    this.selectedSupplier = null;
    if (this.searchText.length >= 3) {
      this.searchTextChanged.next(this.searchText);
      this.NoSearchRecordFound = false;
    }

    if (this.searchText.length == 0) {
      this.getUserSites(true);
      this.NoSearchRecordFound = false;
    }
  }

  getUserSites(isLoading: boolean = true, isSearch: boolean = false) {
    this.isDataLoaded = isLoading;

    this._iS
      .getUserAccountsSites(this.searchText)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (typeof response.result == 'string') {
            this.noAccountsAssigned = true;
          } else {
            if (this.searchText?.length == 0) {
              this.listOfAllocatedSites = [];
              this.listOfSupplierAllocatedSites = [];
              this.listOfSupplierBankAllocatedSites = [];
            }
            this.listOfAccounts = response.result.operator;
            this.listOfSuppliers = response.result.supplier;
            this.listOfSupplierBanks = response.result.supplierBank;

            //fetch sites from all operator accounts
            this.listOfSites = this.listOfAccounts.flatMap((account: any) => account.sites || []);
            //fetch sites from all supplierBank accounts
            const supplierBankSites = this.listOfSupplierBanks.flatMap((account: any) => account.sites || []);
            //merge sites from operator accounts and supplierBank accounts
            this.listOfSBSites = supplierBankSites;


            localStorage.setItem('listOfAccounts', JSON.stringify(this.listOfAccounts?.length || 0));
            localStorage.setItem('listOfSuppliers', JSON.stringify(this.listOfSuppliers?.length || 0));
            localStorage.setItem('listOfSupplierBanks', JSON.stringify(this.listOfSupplierBanks?.length || 0));
            localStorage.setItem('listOfSites', JSON.stringify(this.listOfSites?.length || 0));
            localStorage.setItem('listOfSBSites', JSON.stringify(this.listOfSBSites?.length || 0));

            if (this.listOfAccounts?.length > 0) {
              this.isVisibleAccountFilter = true;
              if (
                Object.keys(this.selectedSupplierDetails)?.length > 0 &&
                !isSearch &&
                this.isPresentInList(
                  'ACCOUNTS',
                  this.selectedSupplierDetails.AccountId
                )
              ) {
                this.selectedAccount = this.selectedSupplierDetails.AccountId;
                this.onSelectAccount(this.selectedAccount);
              }
              // else {
              //   this.onSelectAccount();
              // }
            }
            if (this.listOfSuppliers?.length > 0) {
              this.isVisibleSupplierFilter = true;
              if (
                Object.keys(this.selectedSupplierDetails)?.length > 0 &&
                !isSearch
              ) {
                this.selectedSupplier = this.selectedSupplierDetails.id;
                this.onSelectSupplier(this.selectedSupplier);
              }
              // else {
              //   this.onSelectSupplier();
              // }
            }
            if (this.listOfSupplierBanks?.length > 0) {
              this.isVisibleSupplierBankFilter = true;
              if (
                Object.keys(this.selectedSupplierDetails)?.length > 0 &&
                !isSearch &&
                this.isPresentInList(
                  'SUPPLIERBANK',
                  this.selectedSupplierDetails.AccountId
                )
              ) {
                this.selectedSupplierBank =
                  this.selectedSupplierDetails.AccountId;
                this.onSelectSupplierBank(this.selectedSupplierBank);
              }
              // else {
              //   this.onSelectSupplierBank();
              // }
            }

            localStorage.setItem(
              'AllocatedSites',
              JSON.stringify(response.result)
            );
          }
          this.isDataLoaded = false;
        } else {
          this._cs.displayMessage(
            responseMessageStatus.error,
            response.message
          );
          this.isDataLoaded = false;
          this._cs.logOut();
        }
      });
  }

  isPresentInList(listName: string, accountId: string) {
    if (listName == 'ACCOUNTS') {
      const accountIndex = this.listOfAccounts.findIndex(
        (item) => item.accountId === accountId
      );
      return accountIndex !== -1 ? true : false;
    }

    if (listName == 'SUPPLIER') {
      const supplierIndex = this.listOfSuppliers.findIndex(
        (item) => item.accountId === accountId
      );
      return supplierIndex !== -1 ? true : false;
    }

    if (listName == 'SUPPLIERBANK') {
      const supplierBankIndex = this.listOfSupplierBanks.findIndex(
        (item) => item.accountId === accountId
      );
      return supplierBankIndex !== -1 ? true : false;
    }
  }

  onSelectAccount(event = null) {
    if (event && this.searchText?.length >= 3) {
      const matchedAccount = [
        ...(this.listOfAccounts.find((x: any) => x.accountId === event)
          ?.sites || []),
      ];

      this.listOfAllocatedSites = matchedAccount
      // this.listOfAllocatedSites = matchedAccount.filter((site: any) =>
      //   site.siteName.toLowerCase().includes(this.searchText.toLowerCase())
      // );
      // this.selectedAccount = null;
    } else if (!event && this.searchText?.length >= 3) {
      const accountSitesData = [...this.listOfAccounts];
      this.listOfAllocatedSites = accountSitesData
        .flatMap((account: any) => account.sites || []); // Combine all sites into one array

      // const matchedAccountName = accountSitesData
      //   .filter((account: any) =>
      //     (account.sites || []).some((site: any) =>
      //       site.siteName.toLowerCase().includes(this.searchText.toLowerCase())
      //     )
      //   )
      //   .map((account: any) => account.accountId);

      // this.selectedAccount = matchedAccountName[0];      
    } else {
      this.selectedSupplier = null;
      this.selectedSupplierBank = null;
      this.listOfSupplierBankAllocatedSites = [];
      this.listOfSupplierAllocatedSites = [];

      this.listOfAllocatedSites = [];
      this.listOfAllocatedSites = this.listOfAccounts.find(
        (x: any) => x.accountId == event
      )?.sites;
      this.searchText = null;
    }
  }

  onSelectSupplier(event: any = null) {
    if (event && this.searchText?.length >= 3) {
      this.listOfSupplierAllocatedSites = [event];
      this.listOfSupplierAllocatedSites = this.listOfSupplierAllocatedSites
      // .filter(
      //   (supplier: any) =>
      //     supplier.investorDisplayName
      //       .toLowerCase()
      //       .includes(this.searchText.toLowerCase())
      // );
    } else if (!event && this.searchText?.length >= 3) {
      const supplierSitesData = [...this.listOfSuppliers];
      this.listOfSupplierAllocatedSites = supplierSitesData // Combine all sites into one array
      // .filter((supplier: any) =>
      //   supplier.investorDisplayName.toLowerCase().includes(this.searchText.toLowerCase())
      // );
    } else {

      this.selectedSupplierBank = null;
      this.selectedAccount = null;
      this.listOfSupplierBankAllocatedSites = [];
      this.listOfAllocatedSites = [];

      this.listOfSupplierAllocatedSites = [];
      this.listOfSupplierAllocatedSites = this.listOfSuppliers.filter(
        (x: any) => x.id == event
      );
      this.searchText = null;
    }
    // this.NoSearchRecordFound = false
  }

  onSelectSupplierBank(event: any = null) {
    if (event && this.searchText?.length >= 3) {
      const matchedSupplierBanks = this.listOfSupplierBanks.find(
        (x: any) => x.accountId == event
      )?.sites;

      // this.listOfSupplierBankAllocatedSites = matchedSupplierBanks.filter(
      //   (site: any) =>
      //     site.siteName.toLowerCase().includes(this.searchText.toLowerCase())
      // );
      this.listOfSupplierBankAllocatedSites = matchedSupplierBanks

      // this.selectedSupplierBank = null
    } else if (!event && this.searchText?.length >= 3) {
      const supplierBankSitesData = [...this.listOfSupplierBanks];
      this.listOfSupplierBankAllocatedSites = supplierBankSitesData
        .flatMap((account: any) => account.sites || []); // Combine all sites into one array
      // .filter((site: any) =>
      //   site.siteName.toLowerCase().includes(this.searchText.toLowerCase())
      // );
    } else {
      this.selectedSupplier = null;
      this.selectedAccount = null;
      this.listOfSupplierAllocatedSites = [];
      this.listOfAllocatedSites = [];

      this.listOfSupplierBankAllocatedSites = [];
      this.listOfSupplierBankAllocatedSites = this.listOfSupplierBanks.find(
        (x: any) => x.accountId == event
      )?.sites;

      this.searchText = null;
    }
    // this.NoSearchRecordFound = false
  }

  /** Same sign-out as the in-supplier header: revoke server-side, then clear locally whatever happens. */
  signOut(): void {
    this._iS.logOut().subscribe({
      next: () => this._cs.logOut(),
      error: () => this._cs.logOut(),
    });
  }

  //close switch account modal
  handleCancel() {
    this.isVisibleSwitchAccountModal = false;
    this.hideSwitchAccountModal.emit(this.isVisibleSwitchAccountModal);
    this.location.back();
  }
  //navigate user to landing page once site is selected
  navigateToLandingPage(siteData: any) {
    this.canAccessSummary = this._iS.canAccessSummary().canViewSummary;
    const targetRoute: any = this.canAccessSummary
      ? `supplier/${siteData?.id}/summary?qbo=${siteData?.qboEntityId}`
      : `supplier/${siteData?.id}/programs`;

    if (this.BearerToken) {
      // if (this.isSiteSelected) {
      if (sessionStorage.getItem('SupplierDetails')) {
        const linkToNavigate = window.location.href.includes('localhost')
          ? `http://localhost:4204/${targetRoute}`
          : `${environmentURL.supplierURL}${targetRoute}`;
        // const newTab =
        window.open(linkToNavigate, '_blank');
        // if (newTab) {
        // Clear session storage in the new tab
        // newTab.onload = () => {
        //   newTab.sessionStorage.clear(); // Clear session storage in the new tab
        // };
        // }
        this.handleCancel();
      } else {
        const urlToNavigate = window.location.href.includes('localhost')
          ? `http://localhost:4204/${targetRoute}`
          : `${environmentURL.supplierURL}${targetRoute}`;
        // this._router.navigate([targetRoute]);
        window.open(urlToNavigate, '_parent');
        localStorage.setItem('IsSiteSelected', JSON.stringify(true));
      }
    }
  }

  navigateToPaybevLandingPage(siteId: string) {
    const userInfo = JSON.parse(localStorage.getItem('UserInfo') || '{}');
    const woSpaceEmail = SsoHandoffService.encodeEmail(userInfo.email ?? '');

    // Which page the user lands on is PayBev's call, not ours: this portal's permissions say
    // nothing about PayBev, and naming one of our own pages here (PayBev has no /programs)
    // lands on PayBev's Page Not Found before the hand-off can even run.
    const targetRoute = `paybev/${siteId}`;

    if (this.BearerToken) {
      const buildLink = (code: string) => `${environmentURL.paybevURL}${targetRoute}?t=${code}&e=${woSpaceEmail}&st=${this.BearerToken}`;
      const onFailure = () => this._cs.displayMessage(responseMessageStatus.error, 'Could not open PayBev. Please try again.');

      // const linkToOpen = `http://localhost:4200/${targetRoute
      //   }?t=${woSpaceToken}&e=${woSpaceEmail}&st=${this.BearerToken}`;

      // if (this.isSiteSelected) {
      if (sessionStorage.getItem('SupplierDetails')) {
        this.ssoHandoff.openInNewTab('PAYBEV', buildLink, onFailure);
        this.handleCancel();
      } else {
        localStorage.setItem('IsSiteSelected', JSON.stringify(true));
        this.ssoHandoff.openInNewTab('PAYBEV', buildLink, onFailure);
      }
    }
  }

  customFilterFn = (search: string, option: any): boolean => {
    const normalize = (str: string) =>
      str
        ?.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, ''); // remove accents

    const searchValue = normalize(search);
    const optionLabel = normalize(option.nzLabel);

    return optionLabel.includes(searchValue);
  };
  //#endregion
}
